/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useState} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {AuthIsLoaded, Login, PrivateRoute, PublicRoute} from '../../features/auth'
import Action from '../../features/auth/__auth/action'
import PasswordReset from '../../features/auth/password-reset'
import {Game} from '../../features/game'
import {Home} from '../../features/home'
import {Onboarding} from '../../features/onboarding'
import {NoMatch} from '../../features/no-match'
import {Play} from '../../features/play'
import {RoleSelector} from '../../features/role-selector'
import {StudentProgress} from '../../features/student-progress'
import {Troubleshooting} from '../../features/troubleshooting'
import {Credits} from '../../features/credits'
import {Orders} from '../../features/user'
import Profile from '../../features/user/profile'
import {routes} from '../../utils/config'
import ErrorBoundary from './error-boundary'
import {MainLayout} from '../layout'
import CopyrightModal from './copyright-modal'

const Routes = () => {
  const [isTOSModalOpen, setIsTOSModalOpen] = useState(false)

  const toggleTOSModal = () => {
    setIsTOSModalOpen(state => !state)
  }

  return (
    <Router>
      <ErrorBoundary>
        <AuthIsLoaded>
          <MainLayout id="sotsc-main">
            <CopyrightModal
              isModalOpen={isTOSModalOpen}
              toggleModal={toggleTOSModal}
              content="terms-and-conditions"
            />
            <Switch>
              <PrivateRoute exact path={routes.roleSelector.url} component={RoleSelector} />
              <PrivateRoute exact path={routes.home.url} component={Home} />
              <PrivateRoute exact path={routes.game.url} component={Game} />
              <PrivateRoute exact path={routes.play.url} component={Play} header={false} />
              <PrivateRoute exact path={routes.studentProgress.url} component={StudentProgress} />
              <PrivateRoute exact path={routes.profile.url} component={Profile} />
              <PrivateRoute exact path={routes.enrollments.url} component={Orders} />
              <PrivateRoute exact path={routes.credits.url} component={Credits} />
              <PrivateRoute exact path={routes.troubleshooting.url} component={Troubleshooting} />
              <PrivateRoute exact path={routes.onboarding.url} component={Onboarding} />
              <PublicRoute exact path={routes.login.url} component={Login} />
              <PublicRoute exact path={routes.passwordReset.url} component={PasswordReset} />
              <PublicRoute exact path={routes.action.url} component={Action} />
              <PublicRoute
                exact
                path={routes.signUp.url}
                component={() => {
                  window.location.href = 'https://secretofthesourcecode.com/registration/'
                  return null
                }}
              />
              <Route component={NoMatch} />
            </Switch>
          </MainLayout>
        </AuthIsLoaded>
      </ErrorBoundary>
    </Router>
  )
}

export default Routes
